interface PremiumStyledProps {
  premium: string;
  valueOnly: boolean;
  dollarClasses?: string;
  centsClasses?: string;
  labelClasses?: string;
  perPayText?: string;
  tagName?: keyof JSX.IntrinsicElements;
}

export function convertCurrency(amount: string) {
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(parseFloat(amount));

  return formattedAmount;
}

export function getPremiumStyled({
  premium,
  valueOnly,
  dollarClasses = '',
  centsClasses = '',
  labelClasses = '',
  perPayText,
  tagName = 'h2', // default to h2 if no tagName is provided
}: PremiumStyledProps) {
  const currencyFormat = premium !== undefined && convertCurrency(premium);

  if (valueOnly) {
    return currencyFormat;
  }

  const Tag = tagName;

  const subscriberPremiumDollars =
    currencyFormat && currencyFormat.slice(0, -2);
  const subscriberPremiumCents = currencyFormat && currencyFormat.slice(-2);

  return (
    <>
      <Tag className={`${dollarClasses}`}>
        {subscriberPremiumDollars}
        <sup className={centsClasses} style={{ fontSize: '0.6em' }}>
          {subscriberPremiumCents}
        </sup>
      </Tag>

      {Boolean(perPayText) && (
        <p
          data-testid="per-pay-period"
          className={`body2 mb-0 ${labelClasses}`}
        >{`${perPayText}`}</p>
      )}
    </>
  );
}
